import { render, staticRenderFns } from "./EncounterDetails.vue?vue&type=template&id=5046b138&"
import script from "./EncounterDetails.vue?vue&type=script&lang=js&"
export * from "./EncounterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports